module.exports = __webpack_public_path__ + "static/media/ill_herpes.9385adb8.svg";